(() => {
  const tablinks = document.querySelectorAll('#tab-link-root .tab-link');
  if (tablinks != null) {
    tablinks.forEach((el) => {
      el.addEventListener('click', selectTab);
    });
  }

  function selectTab(evt) {
    const tabcontents = document.querySelectorAll(
      '#tab-content-root .tab-content'
    );
    const target = evt.currentTarget.dataset.target;
    const targetContent = document.getElementById(target);

    for (let i = 0; i < tabcontents.length; i++) {
      tabcontents[i].style.display = 'none';
    }
    targetContent.style.display = 'block';

    for (let i = 0; i < tablinks.length; i++) {
      tablinks[i].classList.remove('tab-link--active');
    }
    evt.currentTarget.classList.add('tab-link--active');
  }
})();
